// @core/api/endpoints/webhook/create_endpoint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateEndpointRequest,
  EndpointResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Create webhook endpoint
 * Registers a new webhook endpoint URL to receive event notifications. A signing secret is generated automatically for payload verification.
 */
export async function CreateEndpoint(
  data: CreateEndpointRequest,
  options?: RequestOptions
): Promise<EndpointResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/endpoints`;
  const requestOptions = options;
  return client.post<EndpointResponse>(requestPath, data, requestOptions);
}
